export const mediaItems = [
  {
    id: "m1",
    kind: "movie",
    title: "流浪地球3",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20film%20poster%20key%20art%2C%20lone%20astronaut%20before%20a%20colossal%20glowing%20planetary%20engine%2C%20deep%20navy%20blue%20and%20cyan%20palette%2C%20dramatic%20volumetric%20lighting%2C%20minimalist%20premium%20composition%2C%20no%20text&width=600&height=900&seq=tianlang-m1&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=epic%20sci-fi%20cinematic%20wide%20banner%2C%20planet%20earth%20with%20giant%20glowing%20engine%20thrusters%20against%20deep%20navy%20space%2C%20cyan%20volumetric%20light%20rays%2C%20dramatic%20atmosphere%2C%20dark%20tones%20for%20text%20overlay%2C%20no%20text&width=1600&height=900&seq=tianlang-hero-m1&orientation=landscape",
    genres: ["科幻", "冒险", "灾难"],
    region: "中国",
    year: 2027,
    rating: 8.9,
    heat: 98,
    director: "郭帆",
    cast: ["吴京", "刘德华", "李雪健", "沙溢"],
    duration: "148分钟",
    synopsis:
      "太阳危机进入最后阶段，地球引擎的推进计划遭遇前所未有的变数。人类在绝望与希望之间做出抉择，一群年轻的宇航员和工程师肩负起守护整个文明的使命，在冰冷的星空中寻找最后的生机。",
    tags: ["科幻", "太空", "灾难", "中国科幻"],
  },
  {
    id: "m2",
    kind: "movie",
    title: "封神第二部：战火西岐",
    cover: "https://readdy.ai/api/search-image?query=epic%20ancient%20chinese%20fantasy%20film%20poster%20key%20art%2C%20heroic%20warrior%20silhouette%20with%20golden%20armor%20against%20storm%20clouds%2C%20rich%20amber%20and%20deep%20teal%20tones%2C%20mystical%20mist%2C%20cinematic%20grandeur%2C%20no%20text&width=600&height=900&seq=tianlang-m2&orientation=portrait",
    genres: ["奇幻", "动作", "古装"],
    region: "中国",
    year: 2026,
    rating: 8.1,
    heat: 92,
    director: "乌尔善",
    cast: ["费翔", "黄渤", "那尔那茜", "陈牧驰"],
    duration: "145分钟",
    synopsis:
      "西岐战火燃起，殷商大军压境。姬发在姜子牙与众将的辅佐下，直面更强大的敌人与更艰难的抉择。神魔交织的战场上，信念与背叛同时上演。",
    tags: ["神话", "史诗", "古装", "大制作"],
  },
  {
    id: "m3",
    kind: "movie",
    title: "满江红·风云再起",
    cover: "https://readdy.ai/api/search-image?query=stylized%20historical%20chinese%20film%20poster%20key%20art%2C%20lone%20general%20in%20red%20robe%20under%20falling%20snow%2C%20ink-wash%20backdrop%2C%20crimson%20and%20charcoal%20palette%2C%20poetic%20dramatic%20atmosphere%2C%20no%20text&width=600&height=900&seq=tianlang-m3&orientation=portrait",
    genres: ["悬疑", "历史", "古装"],
    region: "中国",
    year: 2025,
    rating: 7.8,
    heat: 86,
    director: "张艺谋",
    cast: ["沈腾", "易烊千玺", "张译", "雷佳音"],
    duration: "159分钟",
    synopsis:
      "南宋年间，一桩离奇命案牵出层层阴谋。小人物在权谋的漩涡中步步为营，用一场精心设计的棋局，完成对家国的最后守护。",
    tags: ["悬疑", "权谋", "古装", "群像"],
  },
  {
    id: "m4",
    kind: "movie",
    title: "长津湖",
    cover: "https://readdy.ai/api/search-image?query=gritty%20war%20film%20poster%20key%20art%2C%20soldiers%20advancing%20through%20snowy%20mountains%20at%20dusk%2C%20cold%20blue%20and%20steel%20grey%20palette%2C%20embers%20and%20mist%2C%20heroic%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=tianlang-m4&orientation=portrait",
    genres: ["战争", "历史", "剧情"],
    region: "中国",
    year: 2024,
    rating: 8.3,
    heat: 80,
    director: "陈凯歌",
    cast: ["吴京", "段奕宏", "朱亚文", "易烊千玺"],
    duration: "176分钟",
    synopsis:
      "极寒的长津湖畔，志愿军将士以血肉之躯铸就钢铁防线。冰与火的考验中，普通士兵的勇气与信念被历史永远铭记。",
    tags: ["战争", "历史", "主旋律", "群像"],
  },
  {
    id: "m5",
    kind: "movie",
    title: "唐人街探案4",
    cover: "https://readdy.ai/api/search-image?query=playful%20mystery%20film%20poster%20key%20art%2C%20detective%20silhouette%20in%20a%20neon-lit%20city%20alley%20with%20a%20magnifying%20glass%2C%20warm%20amber%20and%20cool%20shadow%20contrast%2C%20stylish%20graphic%20composition%2C%20no%20text&width=600&height=900&seq=tianlang-m5&orientation=portrait",
    genres: ["喜剧", "悬疑", "动作"],
    region: "中国",
    year: 2026,
    rating: 7.4,
    heat: 88,
    director: "陈思诚",
    cast: ["王宝强", "刘昊然", "周润发", "张子枫"],
    duration: "136分钟",
    synopsis:
      "唐人街再起风波，一桩跨越三国的奇案把老搭档重新聚到一起。笑料与推理齐飞，真相往往藏在最不起眼的细节里。",
    tags: ["喜剧", "推理", "系列", "悬疑"],
  },
  {
    id: "m6",
    kind: "movie",
    title: "深海回响",
    cover: "https://readdy.ai/api/search-image?query=dreamy%20animated%20film%20poster%20key%20art%2C%20luminous%20underwater%20world%20with%20flowing%20red%20and%20teal%20color%20clouds%2C%20child%20silhouette%20drifting%20among%20glowing%20particles%2C%20painterly%20style%2C%20magical%20mood%2C%20no%20text&width=600&height=900&seq=tianlang-m6&orientation=portrait",
    genres: ["动画", "奇幻", "家庭"],
    region: "中国",
    year: 2025,
    rating: 8.0,
    heat: 74,
    director: "田晓鹏",
    cast: ["苏鑫", "王亭文", "滕奎兴"],
    duration: "112分钟",
    synopsis:
      "一个孤独的孩子坠入奇幻的深海世界，在寻找母亲的旅途中遇见光怪陆离的伙伴。绚烂的画面之下，是关于告别与成长的温柔童话。",
    tags: ["动画", "奇幻", "治愈", "国漫"],
  },
  {
    id: "m7",
    kind: "movie",
    title: "消失的她·迷雾",
    cover: "https://readdy.ai/api/search-image?query=tense%20psychological%20thriller%20film%20poster%20key%20art%2C%20woman%20silhouette%20reflected%20in%20cracked%20glass%2C%20muted%20teal%20and%20warm%20amber%20light%2C%20mysterious%20fog%2C%20elegant%20minimalist%20composition%2C%20no%20text&width=600&height=900&seq=tianlang-m7&orientation=portrait",
    genres: ["悬疑", "犯罪", "剧情"],
    region: "中国",
    year: 2025,
    rating: 7.6,
    heat: 82,
    director: "崔睿",
    cast: ["朱一龙", "倪妮", "文咏珊", "杜江"],
    duration: "121分钟",
    synopsis:
      "一场看似普通的失踪案，随着调查深入变得越发离奇。每个人都在说谎，而真相的背后，藏着一段被刻意掩埋的过往。",
    tags: ["悬疑", "犯罪", "反转", "密室"],
  },
  {
    id: "m8",
    kind: "movie",
    title: "孤注一掷",
    cover: "https://readdy.ai/api/search-image?query=crime%20thriller%20film%20poster%20key%20art%2C%20shadowy%20gambling%20table%20with%20scattered%20chips%20and%20a%20glowing%20phone%2C%20dark%20emerald%20and%20amber%20tones%2C%20tense%20noir%20lighting%2C%20no%20text&width=600&height=900&seq=tianlang-m8&orientation=portrait",
    genres: ["犯罪", "剧情", "悬疑"],
    region: "中国",
    year: 2024,
    rating: 7.9,
    heat: 77,
    director: "申奥",
    cast: ["张艺兴", "金晨", "咏梅", "王传君"],
    duration: "130分钟",
    synopsis:
      "一个关于诱惑与陷阱的真实寓言。当欲望被放大到极致，普通人如何在布满算计的漩涡中挣脱，重新找回人生的方向。",
    tags: ["犯罪", "现实题材", "反诈", "剧情"],
  },
  {
    id: "m9",
    kind: "movie",
    title: "独行月球",
    cover: "https://readdy.ai/api/search-image?query=comedic%20sci-fi%20film%20poster%20key%20art%2C%20adorable%20astronaut%20floating%20above%20a%20dusty%20moon%20surface%20with%20distant%20blue%20earth%2C%20warm%20orange%20and%20deep%20blue%20palette%2C%20playful%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=tianlang-m9&orientation=portrait",
    genres: ["喜剧", "科幻", "冒险"],
    region: "中国",
    year: 2024,
    rating: 7.2,
    heat: 70,
    director: "张吃鱼",
    cast: ["沈腾", "马丽", "常远", "李诚儒"],
    duration: "122分钟",
    synopsis:
      "一场意外让维修工独自滞留月球，成为全人类的'直播主角'。在孤独与荒诞中，他用乐观和机智上演了一出宇宙级的喜剧。",
    tags: ["喜剧", "科幻", "开心麻花", "冒险"],
  },
  {
    id: "m10",
    kind: "movie",
    title: "坚如磐石",
    cover: "https://readdy.ai/api/search-image?query=crime%20drama%20film%20poster%20key%20art%2C%20stern%20man%20in%20dark%20suit%20standing%20before%20towering%20city%20glass%20reflections%2C%20cold%20blue%20grey%20palette%2C%20sharp%20noir%20shadows%2C%20no%20text&width=600&height=900&seq=tianlang-m10&orientation=portrait",
    genres: ["犯罪", "剧情", "悬疑"],
    region: "中国",
    year: 2024,
    rating: 7.0,
    heat: 68,
    director: "张艺谋",
    cast: ["雷佳音", "张国立", "于和伟", "周冬雨"],
    duration: "127分钟",
    synopsis:
      "一桩命案牵出盘根错节的利益网络。年轻的警官在亲情与正义之间艰难抉择，试图撬动一块看似坚不可摧的磐石。",
    tags: ["犯罪", "悬疑", "城市", "剧情"],
  },
  {
    id: "m11",
    kind: "movie",
    title: "二手杰作",
    cover: "https://readdy.ai/api/search-image?query=warm%20comedic%20drama%20film%20poster%20key%20art%2C%20writer%20silhouette%20among%20floating%20scattered%20book%20pages%2C%20soft%20amber%20and%20cream%20tones%2C%20gentle%20playful%20mood%2C%20minimal%20cinematic%20key%20art%2C%20no%20text&width=600&height=900&seq=tianlang-m11&orientation=portrait",
    genres: ["喜剧", "剧情", "家庭"],
    region: "中国",
    year: 2025,
    rating: 7.3,
    heat: 63,
    director: "王子昭",
    cast: ["于和伟", "郭麒麟", "倪虹洁", "许恩怡"],
    duration: "118分钟",
    synopsis:
      "一位郁郁不得志的中学语文老师，意外因一场误会成为'畅销作家'。在虚荣与真相的拉扯中，他重新理解了写作与家人的意义。",
    tags: ["喜剧", "剧情", "文学", "家庭"],
  },
  {
    id: "m12",
    kind: "movie",
    title: "三大队",
    cover: "https://readdy.ai/api/search-image?query=intense%20crime%20drama%20film%20poster%20key%20art%2C%20determined%20detective%20silhouette%20in%20heavy%20rain%20under%20streetlight%2C%20deep%20navy%20and%20amber%20glow%2C%20gritty%20cinematic%20atmosphere%2C%20no%20text&width=600&height=900&seq=tianlang-m12&orientation=portrait",
    genres: ["犯罪", "剧情"],
    region: "中国",
    year: 2024,
    rating: 7.7,
    heat: 66,
    director: "戴墨",
    cast: ["张译", "魏晨", "曹炳琨", "王骁"],
    duration: "132分钟",
    synopsis:
      "一桩悬案让刑警队的人生轨迹彻底改写。多年之后，他们以普通人的身份再度踏上追凶之路，只为给当年的遗憾一个交代。",
    tags: ["犯罪", "追凶", "现实题材", "剧情"],
  },
  {
    id: "t1",
    kind: "tv",
    title: "狂飙",
    cover: "https://readdy.ai/api/search-image?query=crime%20drama%20series%20poster%20key%20art%2C%20two%20contrasting%20male%20silhouettes%20facing%20off%2C%20one%20in%20warm%20streetlight%20one%20in%20cold%20shadow%2C%20dark%20navy%20and%20amber%20palette%2C%20gritty%20cinematic%20tension%2C%20no%20text&width=600&height=900&seq=tianlang-t1&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=cinematic%20crime%20drama%20wide%20banner%2C%20rain-soaked%20night%20city%20street%20with%20neon%20signs%20and%20two%20distant%20figures%2C%20dark%20navy%20and%20amber%20tones%2C%20moody%20atmosphere%20for%20text%20overlay%2C%20no%20text&width=1600&height=900&seq=tianlang-hero-t1&orientation=landscape",
    genres: ["犯罪", "剧情", "悬疑"],
    region: "中国",
    year: 2023,
    rating: 9.0,
    heat: 99,
    director: "徐纪周",
    cast: ["张译", "张颂文", "李一桐", "张志坚"],
    episodes: 39,
    status: "完结",
    synopsis:
      "一名坚守底线的刑警与一个从鱼贩崛起的黑恶势力头目，在二十年的时间跨度里展开漫长角力。正义或许会迟到，但从不缺席。",
    tags: ["犯罪", "扫黑", "群像", "现实题材"],
  },
  {
    id: "t2",
    kind: "tv",
    title: "三体",
    cover: "https://readdy.ai/api/search-image?query=epic%20sci-fi%20series%20poster%20key%20art%2C%20giant%20swirling%20galaxy%20above%20a%20lone%20figure%20on%20a%20barren%20plain%2C%20deep%20indigo%20and%20violet-blue%20tones%2C%20cosmic%20scale%2C%20minimalist%20premium%20key%20art%2C%20no%20text&width=600&height=900&seq=tianlang-t2&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=epic%20sci-fi%20series%20wide%20banner%2C%20vast%20starry%20cosmos%20with%20a%20giant%20glowing%20galaxy%20spiral%20over%20a%20silhouetted%20observatory%2C%20deep%20indigo%20tones%2C%20cinematic%20scale%2C%20dark%20for%20text%20overlay%2C%20no%20text&width=1600&height=900&seq=tianlang-hero-t2&orientation=landscape",
    genres: ["科幻", "悬疑", "剧情"],
    region: "中国",
    year: 2023,
    rating: 8.7,
    heat: 94,
    director: "杨磊",
    cast: ["张鲁一", "于和伟", "陈瑾", "王子文"],
    episodes: 30,
    status: "完结",
    synopsis:
      "一场跨越时空的科学谜题，把人类文明的命运推向了宇宙尺度。当来自远方的注视降临，人类该如何回答？",
    tags: ["科幻", "硬核", "宇宙", "改编"],
  },
  {
    id: "t3",
    kind: "tv",
    title: "漫长的季节",
    cover: "https://readdy.ai/api/search-image?query=nostalgic%20suspense%20series%20poster%20key%20art%2C%20empty%20railway%20track%20through%20golden%20autumn%20field%20with%20faint%20factory%20silhouette%2C%20warm%20sepia%20and%20teal%20palette%2C%20melancholic%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=tianlang-t3&orientation=portrait",
    genres: ["悬疑", "剧情", "家庭"],
    region: "中国",
    year: 2023,
    rating: 9.2,
    heat: 90,
    director: "辛爽",
    cast: ["范伟", "秦昊", "陈明昊", "李庚希"],
    episodes: 12,
    status: "完结",
    synopsis:
      "东北小城的一桩旧案，牵出三个普通男人长达二十年的执念。在时代的车轮下，他们固执地追问着那一个没有答案的问题。",
    tags: ["悬疑", "年代", "东北", "人性"],
  },
  {
    id: "t4",
    kind: "tv",
    title: "繁花",
    cover: "https://readdy.ai/api/search-image?query=glamorous%20retro%20series%20poster%20key%20art%2C%20elegant%20figure%20in%20a%201990s%20neon-lit%20shanghai%20street%2C%20warm%20amber%20and%20emerald%20glow%2C%20film-grain%20cinematic%20mood%2C%20luxurious%20key%20art%2C%20no%20text&width=600&height=900&seq=tianlang-t4&orientation=portrait",
    genres: ["剧情", "年代", "商战"],
    region: "中国",
    year: 2024,
    rating: 8.4,
    heat: 85,
    director: "王家卫",
    cast: ["胡歌", "马伊琍", "唐嫣", "辛芷蕾"],
    episodes: 30,
    status: "完结",
    synopsis:
      "九十年代的上海霓虹之下，一群弄潮儿的商海沉浮。在机遇与欲望交织的时代，每个人都在寻找属于自己的那片繁花。",
    tags: ["年代", "上海", "商战", "文艺"],
  },
  {
    id: "t5",
    kind: "tv",
    title: "隐秘的角落",
    cover: "https://readdy.ai/api/search-image?query=creepy%20coming-of-age%20suspense%20series%20poster%20key%20art%2C%20three%20distant%20child%20silhouettes%20on%20a%20rooftop%20under%20pale%20grey%20sky%2C%20muted%20teal%20and%20grey%20palette%2C%20unsettling%20minimal%20mood%2C%20no%20text&width=600&height=900&seq=tianlang-t5&orientation=portrait",
    genres: ["悬疑", "犯罪", "剧情"],
    region: "中国",
    year: 2020,
    rating: 8.8,
    heat: 78,
    director: "辛爽",
    cast: ["秦昊", "王景春", "荣梓杉", "史彭元"],
    episodes: 12,
    status: "完结",
    synopsis:
      "三个孩子在景区无意间拍到一场谋杀，从此卷入一场危险的心理博弈。盛夏的阳光下，隐秘的角落正悄然生长。",
    tags: ["悬疑", "犯罪", "儿童", "人性"],
  },
  {
    id: "t6",
    kind: "tv",
    title: "庆余年2",
    cover: "https://readdy.ai/api/search-image?query=grand%20costume%20drama%20series%20poster%20key%20art%2C%20young%20swordsman%20in%20flowing%20robes%20on%20a%20palace%20rooftop%20at%20dawn%2C%20rich%20crimson%20and%20gold%20tones%2C%20epic%20cinematic%20atmosphere%2C%20no%20text&width=600&height=900&seq=tianlang-t6&orientation=portrait",
    genres: ["古装", "权谋", "喜剧"],
    region: "中国",
    year: 2024,
    rating: 8.2,
    heat: 88,
    director: "孙皓",
    cast: ["张若昀", "李沁", "陈道明", "吴刚"],
    episodes: 36,
    status: "完结",
    synopsis:
      "范闲重回京都，朝堂之上的棋局愈发凶险。在权力与情感的漩涡中，他能否守住心中的那份清明与坚持。",
    tags: ["古装", "权谋", "穿越", "群像"],
  },
  {
    id: "t7",
    kind: "tv",
    title: "长相思",
    cover: "https://readdy.ai/api/search-image?query=romantic%20costume%20drama%20series%20poster%20key%20art%2C%20ethereal%20figure%20in%20pale%20flowing%20hanfu%20amid%20drifting%20petals%20and%20moonlight%2C%20soft%20rose%20and%20jade%20palette%2C%20dreamy%20elegant%20mood%2C%20no%20text&width=600&height=900&seq=tianlang-t7&orientation=portrait",
    genres: ["爱情", "古装", "奇幻"],
    region: "中国",
    year: 2023,
    rating: 7.9,
    heat: 83,
    director: "秦榛",
    cast: ["杨紫", "张晚意", "邓为", "檀健次"],
    episodes: 39,
    status: "完结",
    synopsis:
      "流落高辛的少女在命运的流转中与多位身世各异的男子相遇。爱恨交织的上古传奇里，她逐渐找回自己的身份与归途。",
    tags: ["爱情", "古装", "仙侠", "虐恋"],
  },
  {
    id: "t8",
    kind: "tv",
    title: "莲花楼",
    cover: "https://readdy.ai/api/search-image?query=wuxia%20series%20poster%20key%20art%2C%20elegant%20martial%20artist%20with%20a%20sword%20standing%20on%20a%20misty%20mountain%20peak%2C%20cool%20teal%20and%20silver%20palette%2C%20poetic%20cinematic%20atmosphere%2C%20no%20text&width=600&height=900&seq=tianlang-t8&orientation=portrait",
    genres: ["武侠", "悬疑", "古装"],
    region: "中国",
    year: 2023,
    rating: 8.1,
    heat: 79,
    director: "郭虎",
    cast: ["成毅", "曾舜晞", "肖顺尧", "陈都灵"],
    episodes: 40,
    status: "连载",
    synopsis:
      "昔日的武林盟主退隐江湖，化身游医浪迹天涯。一桩桩离奇案件背后，是他不愿再提的过往与未了的江湖恩怨。",
    tags: ["武侠", "悬疑", "江湖", "群像"],
  },
];